// extracted by css-extract-rspack-plugin
export default {"form":"klkoblxXV1cHbUia","formBody":"SXLfqrQ_dN8V4qu0","wide":"l7t8Q9ehNTkqMs5N","disclaimer":"SLnvpwXUalcEaY8l","successMessage":"TIqazXyk_VcyWpaP"};